import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!username || !password) { setError('Username and password required!'); return; }
    setLoading(true); setError('');
    try {
      const res = await axios.post(
        'https://csksportswear.in/backend/api/auth.php?action=login',
        { username, password }
      );
      if (res.data.success) {
        localStorage.setItem('csk_token', res.data.token);
        localStorage.setItem('csk_user', JSON.stringify(res.data.user));
        const role = res.data.user.role;
        if (role === 'cashier') navigate('/cashier/pos');
        else navigate('/admin/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed!');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', fontFamily: 'Inter, sans-serif' }}>
      <style>{`
        .login-box { width: 100%; max-width: 420px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 40px; }
        @media (max-width: 480px) { .login-box { padding: 24px 20px; } }
        .login-input { width: 100%; padding: 12px 16px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; color: white; font-size: 14px; outline: none; box-sizing: border-box; }
        .login-input:focus { border-color: rgba(0,102,255,0.5); }
      `}</style>
      <div className="login-box">
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '40px', color: '#DC2626', marginBottom: '8px' }}>★</div>
          <h1 style={{ fontFamily: 'Montserrat', fontSize: '22px', fontWeight: 800, letterSpacing: '3px', color: 'white' }}>CSK SPORTSWEAR</h1>
          <p style={{ color: '#94A3B8', fontSize: '13px', marginTop: '4px' }}>Admin Panel</p>
        </div>
        {error && <div style={{ background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '8px', padding: '12px', color: '#DC2626', fontSize: '13px', marginBottom: '20px', textAlign: 'center' }}>{error}</div>}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '8px', color: '#94A3B8' }}>Username</label>
          <input type="text" placeholder="Enter username" value={username} onChange={e => setUsername(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} className="login-input" />
        </div>
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '8px', color: '#94A3B8' }}>Password</label>
          <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} className="login-input" />
        </div>
        <button onClick={handleLogin} disabled={loading} style={{ width: '100%', background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', padding: '14px', borderRadius: '8px', fontSize: '14px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', border: 'none', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <p style={{ color: '#475569', fontSize: '12px', textAlign: 'center', marginTop: '24px' }}>CSK Sports Wear &copy; 2026</p>
      </div>
    </div>
  );
}

export default Login;
